import {
  ContentfulContentType,
  PerkDocument,
} from "@tiicker/util/lib/contentful/types";
import React, { useState } from "react";
import { useContentfulEntries } from "source/contentful/provider";
import styles from "./RecentlyClaimedPerks.module.scss";
import * as TimeDateIso from "@tiicker/util/lib/date-iso/time-date-iso";
import RecentlyClaimedPerkCard from "./RecentlyClaimedPerkCard";
import { getImageReference } from "@tiicker/util/lib/contentful/helpers";
import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/autoplay";
import PerkMegaModal from "../PerkMegaModal/PerkMegaModal";

type Props = {
  perkIds: string[];
};

const RecentlyClaimedPerks = (props: Props) => {
  const [perk, setPerk] = useState<{ perkId: string; tickerSymbol: string }>({
    perkId: "",
    tickerSymbol: "",
  });

  const today = TimeDateIso.now();
  const perkQuery = useContentfulEntries<PerkDocument>(
    ContentfulContentType.Perk,
    {
      query: {
        content_type: ContentfulContentType.Perk,
        "fields.startDate[lte]": today,
        "fields.endDate[gte]": today,
        "sys.id[in]": props.perkIds.join(","),
      },
    }
  );

  if (perkQuery.state !== "DONE") {
    return <></>;
  }

  return (
    <>
      <p className={styles.title}>Recently claimed perks</p>
      <Swiper
        modules={[Autoplay]}
        centeredSlides
        breakpoints={{
          1500: {
            slidesPerView: 4,
          },
          1000: {
            slidesPerView: 3,
          },
          600: {
            slidesPerView: 2,
          },
        }}
        spaceBetween={16}
        slidesPerView={2}
        loop
        autoplay={{
          delay: 2500,
        }}
      >
        {perkQuery.result.items.map((perk) => {
          const logo = getImageReference(
            perk.fields.brand.fields.companyLogo,
            perkQuery.result.includes
          );
          const perkImage = getImageReference(
            perk.fields.image,
            perkQuery.result.includes
          );

          return (
            <SwiperSlide className={styles.slideClass} key={perk.sys.id}>
              <RecentlyClaimedPerkCard
                title={perk.fields.title}
                perkImageUrl={perkImage?.fields.file.url ?? ""}
                logoUrl={logo?.fields.file.url ?? ""}
                backgroundColor={perk.fields.overlayColor}
                tickerSymbol={perk.fields.brand.fields.tickerSymbol}
                onClick={() =>
                  setPerk({
                    perkId: perk.sys.id,
                    tickerSymbol: perk.fields.brand.fields.tickerSymbol,
                  })
                }
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
      {perk.perkId && perk.tickerSymbol && (
        <PerkMegaModal
          perkId={perk.perkId}
          isOpen={perk.perkId !== "" && perk.tickerSymbol !== ""}
          onClose={() => setPerk({ perkId: "", tickerSymbol: "" })}
          ticker={perk.tickerSymbol}
        />
      )}
    </>
  );
};

export default RecentlyClaimedPerks;
